import React, { Component } from 'react'
import { createRoot } from 'react-dom/client'
import CheckoutOrderBump from './CheckoutOrderBump.jsx'
import { getCart } from '../../utils/Cart'

document.addEventListener('DOMContentLoaded', () => {
  getCart((cart) => {
    const checkoutOrderBumpWrapper = document.querySelector('[data-order-bump]')
    if (checkoutOrderBumpWrapper) {
      const cartVariantIds = cart.cart.items.map((item) => item.variant_id)
      let bumpVariant = null
      let description = null
      cart.cart.items.forEach((item) => {
        const bumpVariants = cart.bumps[item.variant_id].variants
        if(bumpVariants && bumpVariants.length > 0) {
          bumpVariants.forEach((variant) => {
            if(variant.available && !cartVariantIds.includes(variant.id) && !bumpVariant) {
              bumpVariant = variant
              description = cart.bumps[item.variant_id].description
            }
          })
        }
      })
      if(bumpVariant) {
        const orderBumpRoot = createRoot(checkoutOrderBumpWrapper)
        orderBumpRoot.render(<CheckoutOrderBump variant={bumpVariant} description={description} />)
      }
    }
  }, false)
})